/* Modulo: Category Slider - scroll-snap arrow controller.
   The rail swipes/scrolls natively (works with no JS); this only wires the
   prev/next arrows and their disabled state. Vanilla, RTL- and
   reduced-motion aware, self-healing across theme-editor re-renders. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function step(rail, card) {
    if (!card) return rail.clientWidth * 0.8;
    var cs = window.getComputedStyle(rail);
    var gap = parseFloat(cs.columnGap || cs.gap) || 0;
    return card.getBoundingClientRect().width + gap; // effective advance per card
  }

  function init(root) {
    if (!root || root.dataset.moduloCsdReady === '1') return;
    root.dataset.moduloCsdReady = '1';

    var rail = root.querySelector('[data-modulo-csd-rail]');
    if (!rail) return;
    var prev = root.querySelector('[data-modulo-csd-prev]');
    var next = root.querySelector('[data-modulo-csd-next]');
    var rtl = window.getComputedStyle(rail).direction === 'rtl';

    function sync() {
      if (!root.isConnected) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var pos = Math.abs(rail.scrollLeft);
      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max - 2;
    }

    function page(dir) {
      var card = rail.querySelector('.modulo-csd__card');
      var s = step(rail, card);
      var perClick = Math.max(1, Math.floor(rail.clientWidth / s));
      var delta = dir * s * perClick * (rtl ? -1 : 1);
      rail.scrollBy({ left: delta, behavior: REDUCE ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    var raf = null;
    rail.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    });

    /* Observe the rail itself rather than the window. Cards are sized in
       percentages, so the arrows' disabled state is a function of the rail's
       own box — and that box changes without the window ever resizing: the
       theme editor's settings panel opening, a cart drawer, a container query.
       A window listener also leaks one handler per section on the page. */
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(function () { sync(); }).observe(rail);
    } else {
      var rt = null;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(sync, 100);
      });
    }

    sync();
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-csd]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Shopify theme editor: (re)init when a section is added/redrawn.
  // Guarded because an identical <script src> still EXECUTES once per tag, so
  // two Category Sliders on one page would otherwise stack two listeners.
  if (!window.moduloCsdWired) {
    window.moduloCsdWired = true;
    document.addEventListener('shopify:section:load', function (e) {
      boot(e.target);
    });
  }
})();
